import { render, staticRenderFns } from "./SystemsTable.vue?vue&type=template&id=0bbcec3a&"
import script from "./SystemsTable.vue?vue&type=script&lang=js&"
export * from "./SystemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports